/* freeship-by studiolab — live updater (Cafellow).
 *
 * The bar is server-rendered correct for the cart at page load, then this script
 * keeps it live: on any cart change Palo Alto rewrites the cart total
 * ([data-cart-total], in cents) but NOT the top-of-drawer bar, so we recompute
 * the label + fill here. Handles both money and "caixas" (boxes) modes. Config
 * comes from the bar's own data-* attributes — no theme coupling.
 *
 * The CTA pill is a sibling of .sl-freeship__text, so rewriting the label
 * never removes it. When the label row overflows (narrow drawer), the pill
 * collapses to a + via .is-cta-compact.
 */
(function () {
  if (window.__slFreeshipInit) return;
  window.__slFreeshipInit = true;

  function fmtMoney(cents, currency, locale) {
    try {
      return new Intl.NumberFormat(locale || 'pt-BR', {
        style: 'currency',
        currency: currency || 'BRL'
      }).format((cents || 0) / 100);
    } catch (e) {
      return 'R$ ' + ((cents || 0) / 100).toFixed(2).replace('.', ',');
    }
  }

  function cartTotalCents() {
    var el = document.querySelector('[data-cart-total]');
    if (!el) return null;
    var v = parseInt(el.getAttribute('data-cart-total'), 10);
    return isNaN(v) ? null : v;
  }

  /* Try the full pill first. The label text has min-width: 7em, so a long
     CTA overflows the row instead of crushing the sentence — that's the
     signal to collapse to a +. Skip while the drawer is still 0-width. */
  function fitCta(bar) {
    var row = bar.querySelector('.sl-freeship__label');
    var cta = bar.querySelector('.sl-freeship__cta');
    if (!row || !cta) return;
    if (bar.classList.contains('sl-freeship--reached')) {
      bar.classList.remove('is-cta-compact');
      return;
    }
    if (row.clientWidth < 8) return;

    bar.classList.remove('is-cta-compact');
    if (row.scrollWidth > row.clientWidth + 1) {
      bar.classList.add('is-cta-compact');
    }
  }

  function watchCta(bar) {
    if (bar.dataset.slCtaFit === 'true') {
      fitCta(bar);
      return;
    }
    bar.dataset.slCtaFit = 'true';
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(function () { fitCta(bar); }).observe(bar);
    }
    fitCta(bar);
  }

  function updateBar(bar, total) {
    var d = bar.dataset;
    var threshold = parseInt(d.slThreshold, 10) || 0;
    if (!threshold) return;
    var targetPrice = parseInt(d.slTargetPrice, 10) || 0;
    var mode = d.slMode || 'money';
    var remaining = threshold - total;
    var pct = Math.max(0, Math.min(100, Math.round((total * 100) / threshold)));

    var fill = bar.querySelector('.sl-freeship__fill');
    var text = bar.querySelector('.sl-freeship__text');
    if (fill) fill.style.width = pct + '%';
    bar.style.setProperty('--sl-fs-pct', pct + '%');

    var reached = remaining <= 0;
    bar.classList.toggle('sl-freeship--reached', reached);
    if (!text) return;

    if (reached) {
      text.innerHTML = d.slMsgReached || '';
    } else if (mode === 'boxes' && targetPrice > 0) {
      var boxes = Math.ceil(remaining / targetPrice);
      if (boxes < 1) boxes = 1;
      /* Portuguese agrees the verb with the noun, so 1 needs its own sentence
         ("Falta 1 caixa"), not the plural one with an "s" trimmed. Same pair of
         templates the Liquid uses, handed over as data attributes. */
      var tpl = boxes === 1
        ? (d.slMsgBoxesOne || 'Falta [caixas] caixa para o frete grátis')
        : (d.slMsgBoxes || 'Faltam [caixas] caixas para o frete grátis');
      text.innerHTML = tpl.replace('[caixas]', '<strong>' + boxes + '</strong>');
    } else {
      var money = fmtMoney(remaining, d.slCurrency, d.slLocale);
      text.innerHTML = (d.slMsgMoney || 'Faltam [valor] para o frete grátis')
        .replace('[valor]', '<strong>' + money + '</strong>');
    }

    fitCta(bar);
  }

  function refresh() {
    var total = cartTotalCents();
    if (total === null) return;
    var bars = document.querySelectorAll('[data-sl-freeship]');
    for (var i = 0; i < bars.length; i++) {
      updateBar(bars[i], total);
      watchCta(bars[i]);
    }
  }

  var last = null;
  var scheduled = false;
  function onMutation() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      var t = cartTotalCents();
      if (t !== null && t !== last) {
        last = t;
        refresh();
      }
    });
  }

  function watchAll() {
    var bars = document.querySelectorAll('[data-sl-freeship]');
    for (var i = 0; i < bars.length; i++) watchCta(bars[i]);
  }

  function init() {
    last = cartTotalCents(); // server render already matches this; only act on change
    watchAll();
    new MutationObserver(onMutation).observe(document.body, {
      childList: true,
      subtree: true
    });
    ['cart:updated', 'cart:refresh', 'cart:change', 'ajaxCart:afterCartLoad'].forEach(function (ev) {
      document.addEventListener(ev, refresh);
    });
    document.addEventListener('shopify:section:load', watchAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
